import React from "react";
import { CButton } from "@coreui/react";
import { downloadUrl } from "src/_apiConfig/apiCall";

const TableButtonAnchor = (props) => {
  const color = props.color || "success";
  return (
    <td className="py-2">
      {props.isDisplayWithOutFileName === true ? (
        <a
          href={`${downloadUrl}/${props.path}`}
          target="_blank"
          className=""
          rel="noreferrer"
        >
          <CButton variant="outline" shape="square" size="sm" color={color}>
            {props.buttonName}
          </CButton>
        </a>
      ) : props.fileName !== "" ? (
        <a
          href={`${downloadUrl}/${props.path}`}
          target="_blank"
          className=""
          rel="noreferrer"
        >
          <CButton variant="outline" shape="square" size="sm" color={color}>
            {props.buttonName}
          </CButton>
        </a>
      ) : (
        ""
      )}
    </td>
  );
};

export default TableButtonAnchor;
